
export const throwTokenError=(queryArray,token,message)=>{
throwQueryError(queryArray,`Invalid token: ${token}\n${message}`)
};


export const throwQueryError=(query,message)=>{
throw new Error(`Invalid query: ${query}\n${message}`)
};